import { useState, useEffect } from 'react'
import { sortStreams } from '../../services/torrentio'
import './StreamSelector.css'

function StreamSelector({ streams, title, onSelect, onClose }) {
  const [selectedStream, setSelectedStream] = useState(null)
  
  // Detect mobile device
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  
  // Auto-enable compatible filter on mobile
  const [showOnlyCompatible, setShowOnlyCompatible] = useState(isMobile)
  
  const sortedStreams = sortStreams(streams)
  const filteredStreams = showOnlyCompatible 
    ? sortedStreams.filter(s => s.browserCompatible)
    : sortedStreams

  const compatibleCount = sortedStreams.filter(s => s.browserCompatible).length

  const handlePlay = () => {
    if (selectedStream) {
      onSelect(selectedStream)
    }
  }

  const getQualityColor = (quality) => {
    switch (quality) {
      case '4K':
      case '2160P':
        return '#FFD700'
      case '1080P':
        return '#00D4AA'
      case '720P':
        return '#4FC3F7'
      default:
        return '#9E9E9E'
    }
  }

  const getCompatibilityIcon = (stream) => {
    if (stream.browserCompatible) return '✅'
    if (!stream.videoCompatible) return '🎬'
    if (!stream.audioCompatible) return '🔊'
    return '⚠️'
  }

  const getCompatibilityTooltip = (stream) => {
    const issues = []
    if (stream.hasHDR) issues.push('HDR')
    if (stream.hasDV) issues.push('Dolby Vision')
    if (!stream.audioCompatible) issues.push('Audio incompatible')
    if (issues.length === 0) return 'Compatible con navegador'
    return `Puede no funcionar: ${issues.join(', ')}`
  }

  return (
    <div className="stream-selector-overlay" onClick={onClose}>
      <div className="stream-selector-container" onClick={(e) => e.stopPropagation()}>
        <div className="stream-selector-header">
          <h3>🎬 {title}</h3>
          <button className="stream-selector-close" onClick={onClose}>✕</button>
        </div>
        
        <div className="stream-selector-content">
          <div className="stream-filter-bar">
            <label className="filter-toggle">
              <input 
                type="checkbox" 
                checked={showOnlyCompatible}
                onChange={(e) => setShowOnlyCompatible(e.target.checked)}
              />
              <span>Solo compatibles ({compatibleCount})</span>
            </label>
            <span className="filter-legend">
              ✅ Compatible | 🎬 HDR/DV | 🔊 Audio
            </span>
          </div>
          
          {isMobile && (
            <div className="mobile-warning">
              📱 Móvil detectado - Mostrando solo streams h264 compatibles
            </div>
          )}
          
          <div className="streams-list">
            {filteredStreams.map((stream, index) => (
              <div 
                key={index}
                className={`stream-item ${selectedStream === stream ? 'selected' : ''} ${!stream.browserCompatible ? 'incompatible' : ''}`}
                onClick={() => setSelectedStream(stream)}
              >
                <div className="stream-quality" style={{ color: getQualityColor(stream.quality) }}>
                  {stream.quality}
                </div>
                <div className="stream-details">
                  <div className="stream-title-row">
                    <span 
                      className="stream-compat-icon" 
                      title={getCompatibilityTooltip(stream)}
                    >
                      {getCompatibilityIcon(stream)}
                    </span>
                    <span className="stream-name" title={stream.title}>{stream.title}</span>
                  </div>
                  <div className="stream-meta">
                    {stream.size && <span>💾 {stream.size}</span>}
                    <span>👥 {stream.seeders} seeders</span>
                    {stream.hasHEVC && <span className="codec-tag">HEVC</span>}
                    {stream.hasHDR && <span className="codec-tag hdr">HDR</span>}
                    {stream.hasDV && <span className="codec-tag dv">DV</span>}
                  </div>
                </div>
              </div>
            ))}
            {filteredStreams.length === 0 && (
              <p className="no-streams">No hay torrents compatibles. Desactiva el filtro para ver todos.</p>
            )}
          </div>
        </div>
        
        <div className="stream-selector-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancelar
          </button>
          <button 
            className="btn btn-primary" 
            onClick={handlePlay}
            disabled={!selectedStream}
          >
            ▶ Reproducir
          </button>
        </div>
      </div>
    </div>
  )
}

export default StreamSelector
